import { Controller } from "@hotwired/stimulus"

// Reconciles a streaming assistant message with server-side DB truth when the
// browser's Action Cable connection may have missed broadcasts — e.g. the
// mobile tab was backgrounded or the network briefly dropped. On tab-visible
// or online events, re-fetches the rendered content fragment and replaces
// the inner HTML.
export default class extends Controller {
  static values = { url: String, streaming: Boolean }

  connect() {
    this.onVisibility = this.onVisibility.bind(this)
    this.onOnline     = this.onOnline.bind(this)
    document.addEventListener("visibilitychange", this.onVisibility)
    window.addEventListener("online", this.onOnline)
  }

  disconnect() {
    document.removeEventListener("visibilitychange", this.onVisibility)
    window.removeEventListener("online", this.onOnline)
  }

  onVisibility() {
    if (document.visibilityState === "visible" && this.streamingValue) this.resync()
  }

  onOnline() {
    if (this.streamingValue) this.resync()
  }

  async resync() {
    try {
      const res = await fetch(this.urlValue, {
        headers:     { Accept: "text/html" },
        credentials: "same-origin",
      })
      if (!res.ok) return
      const html = await res.text()
      this.element.innerHTML = html
    } catch (_) {
      // Best-effort reconciliation; failures are silent.
    }
  }
}
